import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Stack, Typography, useTheme } from '@mui/material';

type PropTypes = {
  close: () => void;
  open: boolean;
};

export const QuestionSubmissionGuidelinesDialog = ({
  close,
  open,
}: PropTypes) => {
  const theme = useTheme();

  return (
    <Dialog open={open} onClose={close} maxWidth="md" fullWidth>
      <DialogTitle>
        <Typography variant="h4" textAlign={'center'}>
          Question Submission Guidelines
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ width: '100%', height: '100%' }}>
        <Stack spacing={2}>
          <Typography variant="h6" sx={{ color: theme.palette.ranked.main }}>
            What are general guidelines to writing PAR questions?
          </Typography>
          <Typography sx={{ color: theme.palette.primary.main }}>
            1. Questions should be clues in sentence form, not actual questions.
            WRONG: Who was the first U.S. President? RIGHT: This person was the
            first U.S. President.
          </Typography>
          <Typography sx={{ color: theme.palette.primary.main }}>
            2. Proper grammar, spelling, and punctuation are required.
            Exception: do NOT end questions with a period or other punctuation.
          </Typography>
          <Typography sx={{ color: theme.palette.primary.main }}>
            3. No more than 24 words.
          </Typography>
          <Typography sx={{ color: theme.palette.primary.main }}>
            4. Make every effort to ensure alternates and prompts are thorough.
          </Typography>
          <Typography sx={{ color: theme.palette.primary.main }}>
            5. Even though answers appear as all caps in the game, please still
            adhere to proper capitalization when you submit. Not only is it
            important for proper nouns to be capitalized, but common nouns need
            to be lowercase so the "plural-checking algorithm" works
          </Typography>
          <Typography variant="h6" sx={{ color: theme.palette.ranked.main }}>
            What happens after I submit a question?
          </Typography>
          <Typography sx={{ color: theme.palette.primary.main }}>
            TriviaDragon will review each submission and either Accept,
            Edit-then-Accept, or Reject. Rejections will give a reason which may
            mean you’ll have an opportunity to re-write it better.
          </Typography>
          <Typography variant="h6" sx={{ color: theme.palette.ranked.main }}>
            How often will my questions be seen?
          </Typography>
          <Typography sx={{ color: theme.palette.primary.main }}>
            It will have a very high (artificially inflated) probability of
            being seen by many people in the first 2 weeks after it’s accepted.
            Afterwards it will go into the main deck as a common question. It’ll
            still indicate that you are the author, but its chance of being
            pulled will be equal to everything else (which is to say, might be
            low).
          </Typography>
          <Typography variant="h6" sx={{ color: theme.palette.ranked.main }}>
            I want to submit more! Submitting each question individually takes
            forever!
          </Typography>
          <Typography sx={{ color: theme.palette.primary.main }}>
            Users who pass a certain benchmark in both quantity and quality
            (TBD) will be given the privilege to submit questions in entire
            batches. This will be a tough privilege to earn but a prestigious
            one if a user can consistently demonstrate the ability to submit
            quality content!
          </Typography>
          <Typography variant="h6" sx={{ color: theme.palette.ranked.main }}>
            Anything else I should know?
          </Typography>
          <Typography sx={{ color: theme.palette.primary.main }}>
            For obvious reasons, you won’t pull your own questions in a real
            game!
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={close} fullWidth>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
